import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Chip,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import ImageIcon from "@mui/icons-material/Image";

const features = [
  {
    id: "login-registration",
    school: "yes",
    description: "Register students, teachers, parents and admins.",
    title: "Login & Registration",
    media: [
      {
        type: "video",
        title:
          "First Time Login to create PIN and Password in a few simple steps.",
        description: "First Time Student Login",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Student_Registration.mp4",
      },
    ],
  },
  {
    id: "timetable-lecture-management",
    school: "yes",
    description: "Create and manage timetables, lectures, and schedules.",
    title: "Timetable & Lecture Management",
    media: [
      // {
      //   type: "video",
      //   title:
      //     "Create and manage class timetables with lectures, subjects, and teacher schedules.",
      //   description: "Timetable Management",
      //   url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Create_Timetable.mp4",
      // },

      {
        type: "video",
        title: "Add Lectures through UI.",
        description: "Timetable Management",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Manage_Timetable_Add_Lecture_Feature.mp4",
      },
      {
        type: "video",
        title: "Add Lectures through Excel in Bulk.",
        description: "Timetable Management",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Timetable_via_Excel_Add_Lecture.mp4",
      },
      {
        type: "video",
        title: "Update or Delete Lectures for a Date.",
        description: "Timetable Management",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Manage_Timetable_Update_Lectures_Feature.mp4",
      },
      {
        type: "video",
        title: "Delete Lectures for Date range.",
        description: "Timetable Management",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Manage_Timetable_Delete_Lectures_Feature.mp4",
      },
      {
        type: "video",
        title:
          "Manage and Track lecture instructions, lecture summary, shared files, online class, recordings, assignments, and assessments effortlessly.",
        description: "Lecture Summary Management",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Lecture_Summary_Feature.mp4",
      },
      {
        type: "image",
        title: "Upload and share class photos, activities, and moments.",
        description: "Class Gallery",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "online-class",
    school: "yes",
    description:
      "Conduct live online classes seamlessly with integrated teaching tools and student access.",
    title: "Online Class",
    media: [
      {
        type: "video",
        title:
          "Easily create Online Class (by Teachers) while Students and Teachers Join.",
        description: "Create and Join Online Class",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Create_and_Join_Online_Class_Feature.mp4",
      },
      {
        type: "video",
        title:
          "Conduct live classes where students and teachers can communicate both ways with enriched features.",
        description: "2-Way Online Class",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Online_Class_Feature_2_Way.mp4",
      },
      {
        type: "image",
        title:
          "Conduct smooth one-way classes where teachers teach and students attend without interruptions.",
        description: "1 Way Online Class",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "content-library-management",
    school: "yes",
    description: "Organize and Manage curriculum contents.",
    title: "Content Library Management",
    media: [
      {
        type: "video",
        title:
          "Access enriched interactive multimedia curriculum contents. Manage notes, bookmarks and queries.",
        description: "Content Library",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Content_Library_View_Content_Personal_Library.mp4",
      },
    ],
  },
  {
    id: "assessment-management",
    school: "yes",
    description:
      "Create tests and assessments, assign them to students, and track results instantly.",
    title: "Assessment Management",
    media: [
      {
        type: "image",
        title:
          "Conduct assessments in multiple formats to match different learning needs.",
        description: "Assessment 3 modes",
        url: "To Prepare",
      },
      {
        type: "video",
        title:
          "Plan, schedule, and manage the complete assessment process end-to-end.",
        description: "Assessment Process",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Assessment_Process.mp4",
      },
      {
        type: "video",
        title:
          "Deliver personalized assessments based on each student's learning level.",
        description: "Adaptive Assessment",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Adaptive_Assessment_Process.mp4",
      },
    ],
  },
  {
    id: "performance-management",
    school: "yes",
    description:
      "Monitor student progress with detailed performance reports and learning insights.",
    title: "Performance Management",
    media: [
      {
        type: "image",
        title:
          "Get intelligent performance insights and progress tracking for every student.",
        description: "Smart Performance",
        url: "To Prepare",
      },
      {
        type: "image",
        title:
          "Record and manage offline test scores and classroom performance easily.",
        description: "Offline Performance",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "assignment-management",
    school: "yes",
    description:
      "Assign homework, Pre-reads and activities digitally, collect submissions, and review everything in one workflow.",
    title: "Assignment Management",
    media: [
      {
        type: "video",
        title:
          "Assign homework digitally, collect submissions, and review student work easily.",
        description: "Homework",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Homework_Process.mp4",
      },
      {
        type: "image",
        title:
          "Share pre-class learning material so students come prepared for the lecture.",
        description: "PreRead",
        url: "To Prepare",
      },
      {
        type: "image",
        title:
          "Create engaging learning activities to boost participation and understanding.",
        description: "Activity",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "question-banks",
    school: "yes",
    title: "Question Banks",
    description: "Create and Manage Question Banks",
    media: [
      {
        type: "video",
        title: "Create Question Banks through School Library and B4S Library",
        description: "Create Question Banks through Library",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Question_Bank_through_Library.mp4",
      },
      {
        type: "video",
        title: "Create Question Banks through AI",
        description: "AI based Query Generation",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/AI_Query_Generation.mp4",
      },
      {
        type: "image",
        title: "Create Question Banks using Question Files",
        description: "Upload Question File",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "doubts-platform",
    school: "yes",
    description:
      "Students ask doubts anytime and get quick responses from peers, teachers or mentors.",
    title: "Doubts Platform",
    media: [
      {
        type: "video",
        title:
          "Allow students to raise doubts anytime and get structured responses.",
        description: "Query Platform",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Query_Platform.mp4",
      },
      {
        type: "image",
        title:
          "Provide instant support and answers to students using AI-powered assistance.",
        description: "AI Chatbot",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "study-planner",
    school: "yes",
    description: "Plan study goals for students to stay consistent and ahead.",
    title: "Study Planner",
    media: [
      {
        type: "video",
        title:
          "Help students plan their studies with daily and weekly learning schedules.",
        description: "Study Planner",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Study_Planner.mp4",
      },
    ],
  },
  {
    id: "self-assessment",
    school: "yes",
    description:
      "Enable students to test themselves regularly and identify improvement areas.",
    title: "Self-Assessment",
    media: [
      {
        type: "video",
        title: "Let students evaluate themselves regularly to improve faster.",
        description: "Self-Assessment",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Self-Assessment.mp4",
      },
    ],
  },
  {
    id: "attendance-management",
    school: "yes",
    description:
      "Mark and track attendance digitally for students in seconds, Notify shortages and reports.",
    title: "Attendance Management",
    media: [
      {
        type: "video",
        title:
          "Mark and manage attendance digitally for students in seconds. Notify shortages and reports.",
        description: "Attendance",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Attendence_Mgt_Feature.mp4",
      },
    ],
  },
  {
    id: "notice-management",
    school: "yes",
    description:
      "Share important announcements instantly with students, parents, and staff with auto-alerts.",
    title: "Notice Management ",
    media: [
      {
        type: "image",
        title:
          "Send official notices and circulars to students and parents instantly.",
        description: "Notice & Circulars",
        url: "To Prepare",
      },
      {
        type: "image",
        title:
          "Deliver important reminders and updates automatically to the right audience.",
        description: "Alerts",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "engagement-community",
    school: "yes",
    description:
      "Build a learning community where students and teachers can interact and stay engaged.",
    title: "Engagement & Community",
    media: [
      {
        type: "video",
        title:
          "Build a learning community where students and teachers stay connected and engaged.",
        description: "Community",
        url: "https://publicbucket.breathe4school.ai/Feature-Guide-Videos/Engagement_Community.mp4",
      },
    ],
  },
  {
    id: "issues-voc-management",
    school: "yes",
    description:
      "Track requests, and voice-of-customer issues with a structured resolution system.",
    title: "Issues / VOC Mgt.",
    media: [
      {
        type: "image",
        title:
          "Capture issues, and requests and manage resolution systematically.",
        description: "Issues / VOC",
        url: "To Prepare",
      },
    ],
  },
  {
    id: "institutional-branding",
    school: "yes",
    description:
      "Customize your institute's identity with branding elements for a professional experience.",
    title: "Institutional Branding",
    media: [
      {
        type: "image",
        title:
          "Create and share high-performing posts across social media to boost reach and engagement quickly",
        description: "Making the Post Viral",
        url: "To Prepare",
      },
    ],
  },
];

export default function FeatureGuide() {
  const [open, setOpen] = useState(false);
  const [activeMedia, setActiveMedia] = useState(null);

  const [expanded, setExpanded] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleMediaClick = (item) => {
    if (item.url === "To Prepare") return;
    setActiveMedia(item);
    setOpen(true);
  };

  return (
    <div
      style={{
        height: "calc(100vh - 100px)",
        overflowY: "auto",
        padding: "40px 20px",
      }}
      className="orange-scrollBar"
    >
      {/* ===== Heading ===== */}
      <div style={{ textAlign: "center", marginBottom: "40px" }}>
        <h2
          style={{
            color: "#ea580c",
            fontWeight: "700",
            fontSize: "28px",
          }}
        >
          Guide for Every Feature
        </h2>
        <p style={{ color: "#6b7280", marginTop: "8px" }}>
          Learn how to use every feature step-by-step with visual guidance
        </p>
      </div>

      {/* ===== Accordion ===== */}
      <div
        style={{ maxWidth: "1200px", margin: "0 auto", overflowX: "scroll" }}
        className="orange-scrollBar"
      >
        {features.map((feature) => (
          <Accordion
            key={feature.id}
            onChange={handleChange(feature.id)}
            expanded={expanded === feature.id}
            sx={{
              marginBottom: "20px",
              borderRadius: "16px",
              border: "1px solid #fed7aa",
              boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
              overflow: "hidden",
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <div>
                <Typography
                  sx={{
                    fontWeight: 600,
                    color: "#ea580c",
                    fontSize: "18px",
                  }}
                >
                  {feature.title}
                </Typography>

                {expanded !== feature.id && (
                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6b7280",
                    }}
                  >
                    Click to view detailed guide
                  </Typography>
                )}
              </div>
            </AccordionSummary>

            <AccordionDetails>
              {/* Card Container */}
              <div
                style={{
                  border: "1px dashed #fed7aa",
                  borderRadius: "16px",
                  padding: "24px",
                  backgroundColor: "#ffffff",
                }}
              >
                {/* ===== Overview Section ===== */}
                <div style={{ marginBottom: "25px" }}>
                  <Chip
                    label="Overview"
                    sx={{
                      backgroundColor: "#fff7ed",
                      color: "#ea580c",
                      fontWeight: "600",
                      marginBottom: "10px",
                    }}
                  />

                  <Typography
                    sx={{
                      fontSize: "14px",
                      color: "#6b7280",
                      lineHeight: "1.6",
                    }}
                  >
                    {feature.description}
                  </Typography>
                </div>

                {/* ===== Media Scroll ===== */}
                <div
                  className="orange-scrollBar"
                  style={{
                    display: "flex",
                    gap: "24px",
                    overflowX: "scroll",
                    paddingBottom: "20px",
                  }}
                >
                  {feature.media.map((item, index) => (
                    <div
                      key={index}
                      onClick={() => handleMediaClick(item)}
                      style={{
                        width: "300px",
                        flexShrink: 0,
                        borderRadius: "20px",
                        border: "1px solid #fed7aa",
                        backgroundColor: "#fff7ed",
                        padding: "20px",
                        cursor:
                          item.url !== "To Prepare" ? "pointer" : "default",
                        transition: "0.3s",
                      }}
                    >
                      {/* Thumbnail */}
                      <div
                        style={{
                          position: "relative",
                          height: "180px",
                          borderRadius: "16px",
                          background:
                            "linear-gradient(135deg, rgba(249,115,22,0.3), rgba(254,215,170,0.3))",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          marginBottom: "16px",
                        }}
                      >
                        {item.type === "video" ? (
                          <PlayCircleIcon
                            sx={{ fontSize: 60, color: "#ea580c" }}
                          />
                        ) : (
                          <ImageIcon sx={{ fontSize: 60, color: "#ea580c" }} />
                        )}

                        <span
                          style={{
                            position: "absolute",
                            bottom: "10px",
                            right: "10px",
                            background: "rgba(0,0,0,0.7)",
                            color: "#fff",
                            fontSize: "11px",
                            padding: "4px 8px",
                            borderRadius: "6px",
                          }}
                        >
                          {item.type === "video" ? "Video demo" : "Image"}
                        </span>
                      </div>

                      <h6
                        style={{
                          textAlign: "center",
                          fontWeight: "600",
                          color: "#c2410c",
                        }}
                      >
                        {item.description}
                      </h6>

                      <p
                        style={{
                          textAlign: "center",
                          fontSize: "14px",
                          color: "#6b7280",
                        }}
                      >
                        {item.title}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        ))}
      </div>

      {/* ===== Dialog ===== */}
      <Dialog open={open} onClose={() => {}} fullWidth maxWidth="md">
        <DialogTitle sx={{ color: "#ea580c", fontWeight: "400" }}>
          {activeMedia?.description}
          <IconButton
            onClick={() => setOpen(false)}
            sx={{ position: "absolute", right: 10, top: 10 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          {/* Description Text */}
          <Typography
            sx={{
              fontSize: "14px",
              color: "#6b7280",
              marginBottom: "15px",
            }}
          >
            {activeMedia?.title}
          </Typography>

          {/* Media */}
          {activeMedia?.type === "video" ? (
            <video
              src={activeMedia?.url}
              controls
              autoPlay
              style={{ width: "100%", borderRadius: "12px" }}
            />
          ) : (
            <div
              style={{
                height: "300px",
                background: "#fff7ed",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              Image Preview
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
